// cargos: [
//   {
//     detailProductItems: 'string',
//     detailProductModel: 'string',
//     detailProductSearchCode: 'string',
//     grossWeight: 0,
//     grossWeightUnit: 'string',
//     productDetailCode: 'string',
//     productParentCode: 'string',
//     productParentName: 'string',
//     projectCode: 'string',
//     qty: 0,
//     qtyUnit: 'string',
//     remarks: 'string',
//     volume: 0,
//     volumeUnit: 'string',
//   },
// ],

export const chartColumns = [
  {
    field: 'productParentName',
    title: '商品名称',
    width: '120',
    editRender: {
      name: 'select',
      // attrs: { type: 'number' },
    },
    //fixme
  },
  {
    field: 'productDetailCode',
    title: '商品子类简码',
    width: '150',
    // editRender: { name: 'amountRound', type: 'default' },
    editRender: { name: 'select', type: 'default' },
  },
  {
    field: 'detailProductItems',
    title: '品目',
    width: '140',
    editRender: {
      name: 'input',
      attrs: { type: 'number' },
      // options: [
      //   {
      //     label: '0',
      //     value: 0,
      //   },
      //   {
      //     label: '1',
      //     value: 1,
      //   },
      //   {
      //     label: '2',
      //     value: 2,
      //   },
      //   {
      //     label: '3',
      //     value: 3,
      //   },
      // ],
    },
    //所选货物主数据自动带出
  },
  {
    field: 'detailProductModel',
    title: '规格',
    width: '140',
    editRender: {
      name: 'input',
    },
    // 所选货物主数据自动带出
  },
  {
    field: 'qty',
    title: '件数',
    width: '140',
    editRender: {
      name: 'input',
      attrs: { type: 'number' },
    },
  },
  {
    field: 'qtyUnit',
    title: '件数单位',
    width: '140',
    editRender: {
      name: 'input',
    },
    //fixme
  },
  {
    field: 'grossWeight',
    title: '毛重',
    width: '140',
    editRender: {
      name: 'input',
      attrs: { type: 'number' },
    },
  },
  {
    field: 'grossWeightUnit',
    title: '毛重单位',
    width: '140',
    editRender: {
      name: 'input',
      attrs: { type: 'number' },
    },
    //fixme
  },
  {
    field: 'volume',
    title: '体积',
    width: '140',
    editRender: {
      name: 'input',
      attrs: { type: 'number' },
    },
  },
  {
    field: 'volumeUnit',
    title: '体积单位',
    width: '140',
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'remarks',
    title: '备注',
    width: '140',
    editRender: {
      name: 'input',
    },
  },
];
